/* eslint eqeqeq:"off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { toast, ToastContainer } from "react-toastify";
import { isEmpty } from "lodash";
import { Button, Col, Input, Modal, Row, Select, Skeleton, Spin } from "antd";
import {
  // PlusOutlined,
  CloseCircleOutlined,
  DownOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import {
  loadPurchaseBarcodeUpdateList,
  loadPurchaseImportRamList,
  loadScanBarcodeList,
} from "../../store/purchase-invoice/actions";
import api from "../../helpers";
import moment from "moment";

const PurchasePriceUpdate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const media = useMedia();
  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";
  const organizationId =
    !isEmpty(userNameDetails) && userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  //Initial state
  const [loading, setLoading] = useState(false);
  const [renderPage, setRenderPage] = useState(false);
  const [barcodeClear, setBarcodeClear] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);
  const [barcodeList, setBarcodeList] = useState([]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    dispatch(loadScanBarcodeList({ organizationId: organizationId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    barcode_update_list = [],
    import_ram_list = [],
    scan_barcode_list = [],
  } = useSelector((state) => state.PurchaseInvoice);

  const barcodeListOptions =
    scan_barcode_list && scan_barcode_list.length > 0
      ? scan_barcode_list.map((data) => {
          return {
            label: data.barcodeNo,
            isSold: data.isSold,
            value: data.barcodeNo,
            _id: data._id,
          };
        })
      : [];
  const ramListOptions =
    import_ram_list && import_ram_list.length > 0
      ? import_ram_list.map((data) => {
          return { label: data.ramName, value: data._id };
        })
      : [];
  console.log(barcodeList, "barcodeList");
  //barcode field
  const fuseOptions = {
    keys: ["barcodeNo", "label"],
  };
  // //header columns
  // const HeaderData = [
  //   {
  //     key: "itemName",
  //     title: <p className="header-purchase-invoice font-semibold">Item Name</p>,
  //     dataIndex: "itemName",
  //     width: "18%",
  //   },
  //   {
  //     key: "purchasePrice",
  //     title: (
  //       <p className="header-purchase-invoice font-semibold">Purchase Price</p>
  //     ),
  //     width: "26%",
  //     dataIndex: "purchasePrice",
  //   },
  //   {
  //     key: "sellingPrice",
  //     title: (
  //       <p className="header-purchase-invoice font-semibold">Sales Price</p>
  //     ),
  //     width: "18%",
  //     dataIndex: "sellingPrice",
  //   },
  //   {
  //     key: "imeiNo",
  //     title: <p className="header-purchase-invoice font-semibold">IMEI No</p>,
  //     // title: "Purchase Order Number",
  //     width: "18%",
  //     dataIndex: "imeiNo",
  //   },
  //   {
  //     key: "ramName",
  //     title: <p className="header-purchase-invoice font-semibold">RAM</p>,
  //     width: "20%",
  //     dataIndex: "ramName",
  //   },
  // ];

  const [priceDetailsArray, setPriceDetailsArray] = useState([
    {
      _id: "",
      modelName: "",
      itemName: "",
      barCodeNo: "",
      brandId: "",
      vendorName: "",
      vendorId: "",
      invoiceNo: "",
      lastpurchasePrice: "",
      lastpurchasePriceDate: "",
      invoiceDate: "",
      brandName: "",
      dateCreated: "",
      itemId: "",
      purchasePrice: 0,
      sellingPrice: 0,
      gradeName: "",
      ramId: "",
      ramName: "",
      imeiNo: "",
    },
  ]);

  const priceDetailDataTable =
    barcode_update_list && barcode_update_list.length > 0
      ? barcode_update_list.map((data) => {
          return {
            _id: data.itemId,
            modelName: data.modelName ? data.modelName : "",
            itemName: data.modelName ? data.modelName : "",
            vendorName: data.vendorName ? data.vendorName : "",
            vendorId: data.vendorId ? data.vendorId : "",
            invoiceNo: data.purchaseinvoiceNo ? data.purchaseinvoiceNo : "",
            invoiceDate: data.purchaseinvoiceDate
              ? data.purchaseinvoiceDate
              : "",
            brandName: data.brandName ? data.brandName : "",
            brandId: data.brandId ? data.brandId : "",
            dateCreated: data.dateCreated,
            purchasePrice: data.purchasePrice ? data.purchasePrice : "",
            sellingPrice: data.sellingPrice ? data.sellingPrice : "",
            barCodeNo: data.barCodeNo,
            gradeName: data.gradeName ? data.gradeName : "",
            ramId: data.ramId ? data.ramId : "",
            ramName: data.ramName ? data.ramName : "",
            imeiNo: data.IMEI ? data.IMEI : "",
            lastpurchasePrice: data.lastpurchasePrice
              ? data.lastpurchasePrice
              : "",
            lastpurchasePriceDate: data.lastpurchasePriceDate
              ? data.lastpurchasePriceDate
              : "",
          };
        })
      : [];

  useEffect(() => {
    if (priceDetailDataTable && priceDetailDataTable.length > 0) {
      setPriceDetailsArray(priceDetailDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barcode_update_list]);
  useEffect(() => {
    setPriceDetailsArray([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(priceDetailsArray, "priceDetailsArray");
  console.log(priceDetailDataTable, "priceDetailDataTable");

  //item Selected on change
  const priceDetailsChange = (e, name, index) => {
    var priceList = priceDetailsArray;
    if (name == "imeiNo") {
      e = e.target.value;
      priceList[index][name] = e;
      setPriceDetailsArray(priceList);
      setRenderPage(!renderPage);
    }
    if (name == "ramId") {
      const ramId = e && ramListOptions.find((data) => data.value === e);

      const ram = ramId && ramId.label && ramId.label;

      priceList[index]["ramId"] = e;
      priceList[index]["ramName"] = ram;
      setPriceDetailsArray(priceList);
      setRenderPage(!renderPage);
    }
    if (name == "sellingPrice") {
      e = e.target.value;
      priceList[index][name] = e;
      setPriceDetailsArray(priceList);
      setRenderPage(!renderPage);
    }
    if (name == "purchasePrice") {
      e = e.target.value;
      priceList[index][name] = e;
      setPriceDetailsArray(priceList);
      setRenderPage(!renderPage);
    }
  };

  const clearFields = () => {
    setBarcodeClear(true);
    setTimeout(() => {
      setBarcodeClear(false);
    }, 0);
    setPriceDetailsArray([
      {
        _id: "",
        modelName: "",
        itemName: "",
        barCodeNo: "",
        brandId: "",
        brandName: "",
        dateCreated: "",
        itemId: "",
        purchasePrice: 0,
        sellingPrice: 0,
        gradeName: "",
        ramId: "",
        ramName: "",
        imeiNo: "",
      },
    ]);
  };

  const priceObj =
    priceDetailsArray &&
    priceDetailsArray.length > 0 &&
    priceDetailsArray[0].itemName
      ? priceDetailsArray[0]
      : "";

  console.log(priceObj, "priceObj");

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const updatePriceList = () => {
    setIsButtonDisabled(true);

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 5000);
    if (priceObj.barCodeNo !== "") {
      setIsButtonDisabled(true);

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
      const priceListObj = {
        Barcode: priceObj ? parseFloat(priceObj.barCodeNo) : "",
        ramId: priceObj ? priceObj.ramId : "",
        sellingPrice:
          priceObj && priceObj.sellingPrice !== null
            ? parseFloat(priceObj.sellingPrice)
            : "",
        purchasePrice: priceObj ? parseFloat(priceObj.purchasePrice) : "",
        imeiNo: priceObj ? priceObj.imeiNo : "",
        organizationId: organizationId,
        updatedBy: userId,
      };

      const priceEmptyObj = Object.keys(priceListObj).forEach(
        (k) =>
          (priceListObj[k] == "" || priceListObj[k] == null) &&
          delete priceListObj[k]
      );
      console.log(priceEmptyObj, "priceEmptyObj");

      api
        .put("/org/updatebarcodes", priceListObj)
        .then((res) => {
          clearFields();
          // setTimeout(() => {
          // const purchaseBarcode = {
          //   organizationId: organizationId,
          //   Barcode: barcodeList && barcodeList.value,
          // };
          toast.success("Price updated successfully");
          // }, 1000);
          return res.data;
        })
        .catch((error) => {
          toast.error(
            error &&
              error.response &&
              error.response.data &&
              error.response.data.error
          );
          return Promise.reject(error);
        });
    } else {
      toast.error("Barcode is required for update the price details");
    }
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      {/* <Layout> */}
      <div className="pl-5">
        <MetaTags>
          <title>Price Update | Mbook</title>
        </MetaTags>
      </div>
      {/* <Row className="bg-[#ffffff]"> */}
      <Row className="bg-[#ffffff]">
        <Col span={24} className="border pb-2 border-b-1 border-x-0 border-t-0">
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[20px] ml-2 mt-1 font-semibold"
              >
                Price Update
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          windowDimensions.height >= 700 && windowDimensions.height <= 767
            ? "dashboard-main-card-medium-device bg-[#ffffff]"
            : windowDimensions.height > 767 && windowDimensions.height < 830
            ? "dashboard-main-card-large-device bg-[#ffffff]"
            : windowDimensions.height > 830 && windowDimensions.height < 900
            ? "dashboard-main-card-extra-large-device bg-[#ffffff]"
            : windowDimensions.height > 900 && windowDimensions.height < 960
            ? "dashboard-main-card-extra-extra-large-device bg-[#ffffff]"
            : windowDimensions.height >= 960 && windowDimensions.height < 1000
            ? "dashboard-main-card-extra-infinite-large-device bg-[#ffffff]"
            : windowDimensions.height >= 1000
            ? "dashboard-main-card-price-extra-infinite-large-device bg-[#ffffff]"
            : "bg-[#ffffff] dashboard-main-card-price-update"
        }
      >
        <Col
          span={24}
          style={{
            height:
              windowDimensions.height >= 700 && windowDimensions.height < 830
                ? "15%"
                : windowDimensions.height > 830 && windowDimensions.height < 900
                ? "16%"
                : windowDimensions.height > 900 && windowDimensions.height < 960
                ? "16%"
                : windowDimensions.height >= 960 &&
                  windowDimensions.height < 1000
                ? "16%"
                : windowDimensions.height >= 1000
                ? "12%"
                : "20%",
          }}
          className="pr-4 pl-4 pt-3 bg-[#ffffff] rounded-md"
        >
          <Row className="pr-2 pl-2 pt-3 pb-2 rounded-md">
            <Col md={6} lg={6} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <ReactSearchAutocomplete
                  name="barcode"
                  key={barcodeClear}
                  items={barcodeListOptions ? barcodeListOptions : []}
                  value={barcodeList}
                  type="autoComplete"
                  resultStringKeyName="label"
                  showIcon={false}
                  onChange={(e) => setBarcodeList(e.target.value)}
                  onSelect={(e) => {
                    setBarcodeList(e);
                    console.log(e, "e");
                    const purchaseBarcode = {
                      organizationId: organizationId,
                      Barcode: e.value,
                    };
                    dispatch(loadPurchaseBarcodeUpdateList(purchaseBarcode));
                    dispatch(loadPurchaseImportRamList());
                  }}
                  onClear={() => {
                    setBarcodeList([]);
                    clearFields();
                  }}
                  showClear
                  placeholder="Scan barcode"
                  fuseOptions={fuseOptions} // Search on both fields
                  className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                  styling={{
                    height: "38px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    boxShadow: "none",
                    textAlign: "end",
                    hoverBackgroundColor: "lightgray",
                    color: "black",
                    // marginBottom: "-3px",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    iconColor: "green",
                    clearIconMargin: "3px 8px 0 0",
                    zIndex: 10,
                  }}
                />
              )}
            </Col>
          </Row>
        </Col>
        <Col
          span={24}
          style={{
            height:
              windowDimensions.height >= 700 && windowDimensions.height < 830
                ? "75%"
                : windowDimensions.height > 830 && windowDimensions.height < 900
                ? "80%"
                : windowDimensions.height > 900 && windowDimensions.height < 960
                ? "82%"
                : windowDimensions.height >= 960 &&
                  windowDimensions.height < 1000
                ? "80%"
                : windowDimensions.height >= 1000
                ? "85%"
                : "80%",
          }}
          className="mb-3 pl-6 pr-6"
        >
          <Row className="border border-1 pl-2 pr-2 pb-4 pt-4">
            <Col md={7} sm={24} lg={7} xs={24} xl={7} xxl={7} className="">
              <Row className="pl-2 mb-2">
                <Col span={24} className="">
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        minWidth: "148%",
                        height: "245px",
                      }}
                      active={true}
                      size={"large"}
                    ></Skeleton.Input>
                  ) : (
                    <Row>
                      <Col
                        md={24}
                        sm={24}
                        lg={24}
                        xs={24}
                        xl={24}
                        xxl={24}
                        className="border border-1 border-lightgray pt-2 pb-2"
                      >
                        <div className="w-[100%] border border-b-1 border-t-0 border-x-0 pl-3 pr-3 pb-2">
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex justify-between pt-1 pb-1"
                          >
                            <h1 className="font-medium">Vendor Name: </h1>
                            <p>
                              {priceObj && priceObj.vendorName
                                ? priceObj.vendorName
                                : "--"}
                            </p>
                          </div>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex justify-between pt-1 pb-1"
                          >
                            <h1 className="font-medium">Invoice No: </h1>
                            <p>
                              {" "}
                              {priceObj && priceObj.invoiceNo
                                ? priceObj.invoiceNo
                                : "--"}
                            </p>
                          </div>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex justify-between pt-1 pb-1"
                          >
                            <h1 className="font-medium">Invoice Date: </h1>
                            <p>
                              {priceObj && priceObj.invoiceDate
                                ? moment(priceObj.invoiceDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : "--"}
                            </p>
                          </div>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex justify-between pt-1 pb-1"
                          >
                            <h1 className="font-medium">Grade</h1>
                            <p>
                              {priceObj && priceObj.gradeName
                                ? priceObj.gradeName
                                : "--"}
                            </p>
                          </div>
                        </div>
                        <div className="w-[100%] mt-4 border border-b-1 border-t-0 border-x-0 pl-3 pr-3 pb-2">
                          <div className="flex justify-between pt-1 pb-1">
                            <h1
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="font-medium"
                            >
                              Last Updated Pur. Price:{" "}
                            </h1>
                            <p className="font-semibold flex">
                              <p className="text-[14px]">
                                {" "}
                                {priceObj &&
                                priceObj.lastpurchasePrice !== "N/A"
                                  ? "₹."
                                  : ""}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Poppins",
                                  marginLeft: "3px",
                                  marginTop: "1px",
                                }}
                              >
                                {priceObj &&
                                priceObj.lastpurchasePrice !== "N/A"
                                  ? priceObj.lastpurchasePrice
                                  : "--"}
                              </p>
                            </p>
                          </div>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex justify-between pt-1 pb-1"
                          >
                            <h1 className="font-medium">Updated Date:</h1>
                            <p>
                              {priceObj &&
                              priceObj.lastpurchasePriceDate !== "N/A"
                                ? moment(priceObj.lastpurchasePriceDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : "--"}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex justify-between pt-1 pb-1 mt-4 pr-3 pl-3"
                        >
                          <h1 className="font-medium">Barcode No:</h1>
                          <p className="font-semibold">
                            {" "}
                            {priceObj && priceObj.barCodeNo
                              ? priceObj.barCodeNo
                              : "--"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>
            <Col
              md={17}
              sm={24}
              lg={17}
              xs={24}
              xl={17}
              xxl={17}
              className={
                media == "sm" || media == "xs"
                  ? "border border-x-0 border-y-0"
                  : "pl-5 pr-2 border border-x-0 border-y-0"
              }
            >
              <table className="sm:overflow-x-auto table-purchase-serial table-responsive">
                <thead>
                  <tr>
                    <th className="w-[15%] table-head uppercase text-[12px] font-medium">
                      Brand Name
                    </th>
                    <th className="w-[17%] table-head uppercase text-[12px] font-medium">
                      Item Name
                    </th>
                    <th className="w-[16%] table-head uppercase text-[12px]">
                      Purchase Price
                    </th>
                    <th className="w-[16%] table-head uppercase text-[12px] font-medium">
                      Sale Price
                    </th>
                    <th className="w-[18%] table-head uppercase text-[12px] font-medium">
                      RAM
                    </th>
                    <th className="w-[18%] table-head uppercase text-[12px] font-medium">
                      IMEI No
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {priceDetailsArray &&
                  priceDetailsArray.length > 0 &&
                  !isEmpty(priceDetailsArray[0].itemName) ? (
                    priceDetailsArray.map((data, index) => {
                      return (
                        <tr key={index} className="table-price-data-row p-5">
                          <td className="table-price-data p-4 font-semibold font-medium text-start">
                            {data.brandName}
                          </td>
                          <td className="table-price-data p-4 font-semibold font-medium text-start">
                            {data.itemName}
                          </td>

                          <td className="table-price-data p-4 font-medium text-center">
                            <Input
                              name="purchasePrice"
                              value={data.purchasePrice}
                              addonBefore={"₹"}
                              className="h-[35px] rounded-sm purchase-orders-inputs text-end"
                              placeholder="Enter price"
                              onChange={(e) =>
                                priceDetailsChange(e, "purchasePrice", index)
                              }
                              disabled={
                                barcodeList && barcodeList.isSold == true
                                  ? true
                                  : false
                              }
                              style={{
                                textAlign: "right",
                              }}
                            />
                          </td>

                          <td className="table-price-data p-4 font-medium text-center">
                            <Input
                              name="sellingPrice"
                              value={data.sellingPrice}
                              addonBefore={"₹"}
                              className="h-[35px] rounded-sm purchase-orders-inputs text-end"
                              placeholder="Enter price"
                              disabled={
                                barcodeList && barcodeList.isSold == true
                                  ? true
                                  : false
                              }
                              onChange={(e) =>
                                priceDetailsChange(e, "sellingPrice", index)
                              }
                              style={{
                                textAlign: "right",
                              }}
                            />
                          </td>
                          <td className="table-price-data p-4 font-medium text-start">
                            <Select
                              name="ramId"
                              value={data.ramId}
                              options={ramListOptions}
                              onChange={(e) =>
                                priceDetailsChange(e, "ramId", index)
                              }
                              suffixIcon={
                                data.ramId ? (
                                  <CloseCircleOutlined
                                  // onClick={() => {
                                  //   data.ramId = "";
                                  //   data.ramName = "";
                                  // }}
                                  />
                                ) : (
                                  <DownOutlined />
                                )
                              }
                              allowClear
                              className="h-[35px] rounded-sm w-[100%] border-none"
                              placeholder="Select Ram"
                            />
                          </td>
                          <td className="table-price-data p-4 font-medium text-center">
                            <Input
                              name="imeiNo"
                              value={data.imeiNo}
                              className="p-2 h-[35px] purchase-orders-inputs"
                              placeholder="Enter imei no"
                              onChange={(e) =>
                                priceDetailsChange(e, "imeiNo", index)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : loading ? (
                    <tr key={0} className="table-price-no-data-row p-3">
                      <td
                        colSpan={6}
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-center p-3"
                      >
                        <Spin className="text-[20px]" />
                      </td>
                    </tr>
                  ) : (
                    <tr key={0} className="table-price-no-data-row p-3">
                      <td
                        colSpan={6}
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-center p-3"
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Row>
                <Col
                  md={24}
                  sm={24}
                  lg={24}
                  xs={24}
                  xl={24}
                  xxl={24}
                  className="flex justify-end mt-[140px]"
                >
                  <div className="flex">
                    <div
                      onClick={clearFields}
                      className="cursor-pointer pt-[4px] pb-[4px] pl-4 pr-4 text-[white] price-update-label bg-[#f44336] hover:bg-[red] focus:bg-[red] mr-2 rounded-sm border-none"
                    >
                      Reset
                    </div>
                    <Button
                      type="primary"
                      disabled={isButtonDisabled ? true : false}
                      onClick={updatePriceList}
                      className="price-update-label rounded-sm border-none"
                    >
                      Update
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mb-3"></Col>
        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            setPriceDetailsArray([]);
            history.push("/dashboard");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

PurchasePriceUpdate.propTypes = {
  location: PropTypes.any,
};

export default PurchasePriceUpdate;
